// Billing postal code: 4 to 6 digits (billing addresses can be overseas).
// Keep in sync with BillingAddress::POSTAL_CODE_FORMAT. Delivery/serving
// addresses and Locations keep their own 6-digit Singapore rules.
export const BILLING_POSTAL_CODE_PATTERN = /^\d{4,6}$/;

export function isBillingPostalCodeValid(value: string | null | undefined): boolean {
  return BILLING_POSTAL_CODE_PATTERN.test(value?.trim() ?? '');
}

export const PLACEHOLDER_POSTAL_CODE = '000000';

export function isPlaceholderPostalCode(value: string | null | undefined): boolean {
  return value?.trim() === PLACEHOLDER_POSTAL_CODE;
}
